/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Tool usage user identity kind
 */
export const ToolUsageUserSummaryUserKind = {
  Email: "email",
  ExternalUserId: "external_user_id",
  UserId: "user_id",
  AgentId: "agent_id",
  Unknown: "unknown",
} as const;
/**
 * Tool usage user identity kind
 */
export type ToolUsageUserSummaryUserKind = OpenEnum<
  typeof ToolUsageUserSummaryUserKind
>;

/**
 * Aggregated tool usage metrics for one user identity
 */
export type ToolUsageUserSummary = {
  /**
   * Total number of tool usage events for the user identity
   */
  eventCount: number;
  /**
   * Number of failed tool usage events for the user identity
   */
  failureCount: number;
  /**
   * Fraction of completed tool usage events for the user identity that failed
   */
  failureRate: number;
  /**
   * Number of successful tool usage events for the user identity
   */
  successCount: number;
  /**
   * Number of distinct tools observed for the user identity
   */
  uniqueTools: number;
  /**
   * Stable user identity value used by filters and chart grouping
   */
  userKey: string;
  /**
   * Tool usage user identity kind
   */
  userKind: ToolUsageUserSummaryUserKind;
  /**
   * User-facing label for the user identity
   */
  userLabel: string;
};

/** @internal */
export const ToolUsageUserSummaryUserKind$inboundSchema: z.ZodMiniType<
  ToolUsageUserSummaryUserKind,
  unknown
> = openEnums.inboundSchema(ToolUsageUserSummaryUserKind);

/** @internal */
export const ToolUsageUserSummary$inboundSchema: z.ZodMiniType<
  ToolUsageUserSummary,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    failure_count: z.int(),
    failure_rate: z.number(),
    success_count: z.int(),
    unique_tools: z.int(),
    user_key: z.string(),
    user_kind: ToolUsageUserSummaryUserKind$inboundSchema,
    user_label: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "failure_rate": "failureRate",
      "success_count": "successCount",
      "unique_tools": "uniqueTools",
      "user_key": "userKey",
      "user_kind": "userKind",
      "user_label": "userLabel",
    });
  }),
);

export function toolUsageUserSummaryFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageUserSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageUserSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageUserSummary' from JSON`,
  );
}
